// @ts-check
/** @jsx jsx */
import { jsx } from 'theme-ui';

export default function ListRowBody({ children, ...rest }) {
  return (
    <div sx={{ padding: 3, flex: 1 }} {...rest}>
      {children}
    </div>
  );
}
